
import { Component, Vue, Watch } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'

@Component({
  name: 'Login'
})
export default class extends Vue {
  get language() {
    return AppModule.language
  }

  private handleSetLanguage(lang: string) {
    this.$i18n.locale = lang
    AppModule.SetLanguage(lang)
    if (this.language === 'en') {
      this.$message({
        message: 'Switch Language Success',
        type: 'success'
      })
    }
    if (this.language === 'zh_cn') {
      this.$message({
        message: '切换语言成功',
        type: 'success'
      })
    }
    if (this.language === 'zh_tw') {
      this.$message({
        message: '切換語言成功',
        type: 'success'
      })
    }
  }
}
